import * as PropTypes from 'prop-types';
import FirebaseContext, { withFirebase } from './context';
import Firebase from './firebase';

export default Firebase;

const FirebasePropType = PropTypes.instanceOf(Firebase);

export { FirebaseContext, withFirebase, FirebasePropType };
